const MANTINE_THEME = {
    LIGHT: "light",
    DARK: "dark"
}
export default MANTINE_THEME;